if (!customElements.get('hale-sales-gallery')) {
 customElements.define('hale-sales-gallery', class extends HTMLElement {
  connectedCallback() {
   if (this._abort) return;
   this._abort = new AbortController();
   this.track = this.querySelector('.hale-gallery-track');
   this.slides = [...this.querySelectorAll('.hale-gallery-slide')];
   this.thumbs = [...this.querySelectorAll('[data-hale-slide]')];
   this.index = 0;
   const opts={signal:this._abort.signal};
   this.addEventListener('click', e => {
    const thumb=e.target.closest('[data-hale-slide]');
    if(thumb) this.go(Number(thumb.dataset.haleSlide));
    else if(e.target.closest('[data-hale-prev]')) this.go(this.index-1);
    else if(e.target.closest('[data-hale-next]')) this.go(this.index+1);
   },opts);
   this.track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.go(this.index+(e.key==='ArrowRight'?1:-1));}},opts);
   this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this._frame);this._frame=requestAnimationFrame(()=>this.sync());},{...opts,passive:true});
   this.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s===e.target||s.contains(e.target));if(i>=0)this.go(i);},opts);
   this.sync();
  }
  go(i){i=Math.max(0,Math.min(this.slides.length-1,i));const s=this.slides[i];if(!s)return;this.track.scrollTo({left:s.offsetLeft-this.slides[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
  sync(){if(!this.slides.length)return;const left=this.track.getBoundingClientRect().left;let closest=0,distance=Infinity;this.slides.forEach((s,i)=>{const d=Math.abs(s.getBoundingClientRect().left-left);if(d<distance){distance=d;closest=i;}});this.index=closest;this.thumbs.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===closest)));this.querySelector('[data-hale-counter]').textContent=`${closest+1} / ${this.slides.length}`;this.querySelector('[data-hale-prev]').disabled=closest===0;this.querySelector('[data-hale-next]').disabled=closest===this.slides.length-1;}
  disconnectedCallback(){this._abort?.abort();this._abort=null;cancelAnimationFrame(this._frame);}
 });
}
